import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { Config } from '@nw/shared/config';
import { getAPIErrorResponse } from '@nw/shared/utils';

const useGetClientConfig = (): {
  getClientConfigAPI: UseMutateAsyncFunction<
    any,
    unknown,
    {
      clientId: string;
    },
    unknown
  >;
  error: string;
  status: MutationStatus;
} => {
  const getClientConfigData = async ({ clientId }: { clientId: string }) => {
    const uniqueId = Date.now();
    return await fetch(
      `https://nw-user-accounts-backend-media-static.s3.ap-south-1.amazonaws.com/${Config['ENVIRONMENT']}/client_auth_layout_configs/${clientId}/auth_layout_config.json?time=${uniqueId}`
    ).then((res) => res.json());
  };

  const { mutateAsync, error, status } = useMutation(getClientConfigData, {
    retry: 3,
    retryDelay: (attempt) =>
      Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 20 * 1000)
  });

  const getClientConfigAPI = mutateAsync;
  return {
    getClientConfigAPI,
    status,
    error: error ? getAPIErrorResponse(error) : ''
  };
};

export { useGetClientConfig };
